/** Calendar date in device local timezone (YYYY-MM-DD). */
export function todayIsoDate(): string {
  return new Date().toLocaleDateString('en-CA');
}

/** Local datetime for HTML `datetime-local` inputs (YYYY-MM-DDTHH:mm). */
export function nowDatetimeLocalValue(): string {
  const d = new Date();
  d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
  return d.toISOString().slice(0, 16);
}

/**
 * Parse `YYYY-MM-DD` / `YYYY-MM-DDTHH:mm(:ss)` as calendar parts.
 * Never use `new Date('YYYY-MM-DD')` — UTC midnight → day-1 in America/Bogota.
 */
export function matchIsoLocalCalendar(raw: string): {
  y: string;
  m: string;
  d: string;
  hh?: string;
  mm?: string;
  ss?: string;
} | null {
  const hit = raw.trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{2}):(\d{2})(?::(\d{2}))?)?/);
  if (!hit) return null;
  return { y: hit[1]!, m: hit[2]!, d: hit[3]!, hh: hit[4], mm: hit[5], ss: hit[6] };
}

/** `DD/MM/YYYY` from ISO calendar date. `null` if not ISO. */
export function formatIsoLocalDateDdMmYyyy(value: string): string | null {
  const parts = matchIsoLocalCalendar(value);
  if (!parts) return null;
  return `${parts.d}/${parts.m}/${parts.y}`;
}

/** `DD/MM/YYYY HH:mm:ss` from ISO local datetime. `null` if not ISO. */
export function formatIsoLocalDateTimeDdMmYyyy(value: string): string | null {
  const parts = matchIsoLocalCalendar(value);
  if (!parts) return null;
  const pad = (n: string | undefined) => String(n ?? '00').padStart(2, '0');
  return `${parts.d}/${parts.m}/${parts.y} ${pad(parts.hh)}:${pad(parts.mm)}:${pad(parts.ss)}`;
}

export function shortPublicId(publicId: string): string {
  return publicId.length > 8 ? `${publicId.slice(0, 8)}…` : publicId;
}

/** Strip non-digits while typing cédula / documento fields. */
export function digitsOnlyInput(value: string): string {
  return value.replace(/\D/g, '');
}

/** Strip digits while typing person-name fields. */
export function nameTextInput(value: string): string {
  return value.replace(/\d/g, '');
}
